import { clear } from '@lx/shared/utils-http';
import { pipe, tap } from 'rxjs';

export function clearMemoizeCacheOnError(...tags: string[]) {
  return pipe(tap({ error: () => clear(tags) }));
}
